var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 47,
    viewBox: "0 0 43 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41504 32.9572C6.76637 32.7063 7.11769 32.4553 7.44392 32.2295C11.4089 29.4189 15.1731 26.7337 20.7692 29.996C21.0954 29.996 21.497 29.9709 21.9236 29.9458C24.6589 29.8455 28.7744 29.6949 30.6565 31.6272C31.0831 32.0538 31.3592 32.5557 31.5098 33.1329C29.5775 34.764 24.6338 35.3663 22.2498 35.6173C22.0741 35.6423 21.9236 35.7929 21.9487 35.9686C21.9738 36.1693 22.1243 36.2948 22.3 36.2697C24.9098 35.9937 30.6063 35.2408 32.4132 33.0074C32.5135 32.8819 32.5888 32.7565 32.6641 32.631C35.2238 30.8242 38.6116 28.4904 40.9956 29.193C41.8488 29.444 42.4761 30.0713 42.8526 31.0249C42.9529 31.2759 42.8777 31.5519 42.6518 31.7025C40.7195 33.0325 39.0131 34.3123 37.5074 35.4165C30.1295 40.9122 26.3904 43.6978 14.0689 40.4605L11.6347 41.8658L6.41504 32.9572Z",
    fill: "#278176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5298 30.7257C32.1358 29.6968 34.3693 28.2915 36.1761 28.7432C36.5525 28.8185 36.8787 28.9941 37.1548 29.22C35.348 29.9979 33.5662 31.2778 32.3115 32.1561L32.2111 32.2314L32.1358 32.3568C32.0857 32.4572 32.0355 32.5325 31.9602 32.6329C31.7845 32.0808 31.4834 31.6291 31.0819 31.2025C30.9062 31.0268 30.7305 30.8762 30.5298 30.7257Z",
    fill: "#278176"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0917 46.5097C6.89094 46.5097 6.69018 46.4093 6.5898 46.2336L0.190652 35.2923C0.115368 35.1418 0.0902728 34.9912 0.115368 34.8406C0.165557 34.7152 0.265936 34.5897 0.391409 34.4893L4.55713 32.0551C4.83317 31.9046 5.1845 32.0049 5.33507 32.2559L11.7342 43.2223C11.8346 43.3477 11.8346 43.4983 11.8095 43.6489C11.7593 43.7994 11.684 43.9249 11.5335 44.0002L7.36774 46.4344C7.26736 46.4846 7.19208 46.5097 7.0917 46.5097Z",
    fill: "#278176"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2237 32.6376C22.8974 32.6376 22.6465 32.3866 22.6465 32.0855V22.0225C22.6465 21.6963 22.8974 21.4453 23.2237 21.4453C23.5248 21.4453 23.7757 21.6963 23.7757 22.0225V32.0855C23.7757 32.3866 23.5248 32.6376 23.2237 32.6376Z",
    fill: "#278176"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9219 20.2983C21.8654 20.3318 21.764 20.354 21.6907 20.3593C15.3049 21.6352 10.1867 18.4894 6.47107 10.9564C6.36501 10.7138 6.37186 10.4041 6.54731 10.1851C6.72275 9.96617 6.99356 9.84334 7.29185 9.8952C14.1523 11.0879 18.8837 12.3624 22.2186 19.3195C22.3079 19.5339 22.2957 19.7704 22.1935 19.984C22.1423 20.0908 22.0348 20.2311 21.9219 20.2983Z",
    fill: "#278176"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2234 22.5697C23.0227 22.5697 22.8219 22.4693 22.7215 22.2936L21.2751 19.9963C21.1246 19.7203 21.2249 19.369 21.501 19.2184C21.777 19.0678 22.1032 19.1682 22.2789 19.4442L23.7002 21.7164C23.8508 21.9925 23.7755 22.3438 23.4995 22.4944C23.3991 22.5446 23.2987 22.5697 23.2234 22.5697Z",
    fill: "#278176"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3199 19.1633C25.2078 19.1299 25.0582 19.0852 24.9684 18.977C24.7776 18.7979 24.6576 18.5179 24.6983 18.245C25.5279 10.5542 30.9092 5.89079 40.7712 4.3558C41.0775 4.28437 41.4402 4.4333 41.6087 4.68714C41.8146 4.95213 41.8263 5.32203 41.6997 5.60992C37.9104 12.9874 34.7714 17.9129 25.716 19.2001C25.5816 19.2414 25.4694 19.2079 25.3199 19.1633Z",
    fill: "#278176"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2232 22.5677C23.1228 22.5677 23.0224 22.5426 22.922 22.4924C22.646 22.3418 22.5707 21.9905 22.7213 21.7144L24.7539 18.2012C24.9045 17.9502 25.2558 17.8499 25.5319 18.0004C25.8079 18.151 25.8832 18.5023 25.7326 18.7784L23.7 22.2916C23.5996 22.4673 23.3988 22.5677 23.2232 22.5677Z",
    fill: "#278176"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon_energy.a66d74cbc35573f1be217657637891e5.svg";
export { ForwardRef as ReactComponent };